module.exports = __webpack_public_path__ + "static/media/turn-off.68f86425.svg";